export default [
  {
    path: '/campus-attendances',
    name: 'campus-attendance',
    meta: { requiresAuth: true },
    component: () => import('@/pages/campus-attendance/index.vue')
  }
]
